<template>
  <div class="main-content">
    <top-container
      :image="headerImage"
      :pageTitle="pageTitle"
      :isHomepage="homepage" />

    <col-3
      title=""
      :content="content" />

  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {
      content: '<div class="not-found"><h1>404 - Page not found.</h1>The page you\'re looking for is not available.</div>',
      website: null,
      currLang: {
        isoCode: 'nl',
        name: 'Dutch',
        id: ''
      },
      quotes: [],
      cookieText: '',
      cookieApprove: '',
      cookieDisapprove: '',
      siteName: 'AIS',
      siteEmail: '',
      sitePhone: '',
      siteAddress: '',
      logo: [],
      homepage: false,
      pageTitle: '404 - Page not found',
      headerImage: '/img/header-parked.jpg',
      metaDescription: 'Page not found'
    }
  },
  metaInfo () {
    return {
      title: '404 - Page Not Found',
      titleTemplate: '%s | ' + this.siteName,
      meta: [
        { vmid: 'description', name: 'description', content: this.metaDescription }
      ],
      // link: this.getAlternativeLinks,
      htmlAttrs: {
        lang: 'en'
      }
    }
  }
}
</script>

<style>
.not-found {
  position: relative;
  padding-top: 25vh;
  z-index: 5;
}
</style>
